import Chartist from 'chartist';

import './tooltip-plugin.scss';

const defaultOptions = {
  tooltipOffset: {
    x: 0,
    y: -20
  },
  anchorToPoint: false,
  class: 'chartist-tooltip',
  pointClass: 'chart-point'
};

const labels = {
  usc: 'ДОХОДНОСТЬ ПРОГРАММЫ USC',
  reference: 'ИНДЕКС ММВБ',
  deposit: 'ДОХОДНОСТЬ ДЕПОЗИТА'
};

export default function(options) {
  options = Chartist.extend({}, defaultOptions, options);

  return function tooltip(chart) {
    const tooltipSelector = options.pointClass;
    const $chart = chart.container;
    let $toolTip = $chart.querySelector('.chartist-tooltip');

    if (!$toolTip) {
      $toolTip = document.createElement('div');
      $toolTip.className = options.class;
      $chart.appendChild($toolTip);
    }

    let height = $toolTip.offsetHeight;
    let width = $toolTip.offsetWidth;

    hide($toolTip);

    function on(event, selector, callback) {
      $chart.addEventListener(event, function(e) {
        if (!selector || hasClass(e.target, selector)) {
          callback(e);
        }
      });
    }

    on('mouseover', tooltipSelector, function(event) {
      const $point = event.target;
      let tooltipText = '';

      let value = $point.getAttribute('ct:value');
      let seriesName = $point.parentNode.getAttribute('ct:series-name');
      let meta = $point.getAttribute('ct:meta');

      if (value) {
        value = `<span class="chartist-tooltip-value">${value}%</span>`;
        tooltipText += value + '<br/>';
      }

      if (seriesName) {
        seriesName = `<span class="chartist-tooltip-meta">${labels[seriesName]}</span>`;
        tooltipText += seriesName + '<br/>';
      }

      if (meta) {
        meta = `<span class="chartist-tooltip-meta">${meta}</span>`;
        tooltipText += meta;
      }

      if (tooltipText) {
        $toolTip.innerHTML = tooltipText;
        setPosition(event);
        show($toolTip);

        // Remember height and width to avoid wrong position in IE
        height = $toolTip.offsetHeight;
        width = $toolTip.offsetWidth;
      }
    });

    on('mouseout', tooltipSelector, function() {
      hide($toolTip);
    });

    on('mousemove', null, function(event) {
      if (options.anchorToPoint === false) {
        setPosition(event);
      }
    });

    function setPosition(event) {
      height = height || $toolTip.offsetHeight;
      width = width || $toolTip.offsetWidth;
      const offsetY = 7;

      const box = $chart.getBoundingClientRect();

      let top = event.pageY - box.top - window.pageYOffset;
      let left = event.pageX - box.left - window.pageXOffset;

      const isAlignToLeft = left + $toolTip.offsetWidth < box.width;

      $toolTip.classList.remove(isAlignToLeft ? 'right' : 'left');
      $toolTip.classList.add(isAlignToLeft ? 'left' : 'right');

      if (left + $toolTip.offsetWidth > box.width) {
        left -= $toolTip.offsetWidth;
      }

      $toolTip.style.top = top + offsetY + 'px';
      $toolTip.style.left = left + 'px';
    }
  };
};

function show(element) {
  if (!hasClass(element, 'tooltip-show')) {
    element.className = `${element.className} tooltip-show`;
  }
}

function hide(element) {
  const regex = new RegExp('tooltip-show\\s*', 'gi');
  element.className = element.className.replace(regex, '').trim();
}

function hasClass(element, className) {
  return (' ' + element.getAttribute('class') + ' ').indexOf(' ' + className + ' ') > -1;
}



// WEBPACK FOOTER //
// ./src/components/Chart/TooltipPlugin.js